import { useQuery } from '@apollo/experimental-nextjs-app-support/ssr'

import { SubscriptionPlanEnum, UseCurrentUser_UsersDocument, UsersRoleEnum } from '@gql/graphql'

export type TTokenTypes =
  | 'achievements'
  | 'coverLetter'
  | 'interview'
  | 'interviewQuestions'
  | 'jobMatch'
  | 'learnSkills'
  | 'professionalSummary'
  | 'salaryInsights'

type TTokens = { [key in TTokenTypes]: number | undefined }

export const useCurrentUser = () => {
  const { data, loading } = useQuery(UseCurrentUser_UsersDocument)
  const user = data?.user
  const business = user?.business
  const paidPlans = [
    SubscriptionPlanEnum.Pro,
    SubscriptionPlanEnum.Basic,
    SubscriptionPlanEnum.Hobby,
  ]
  const isPaidPlan = business?.plan ? paidPlans.includes(business.plan) : false
  // const isLifetimePaidUser = isPaidPlan && !user?.hasSubscription

  const isAdvisor = false // user?.role === UsersRoleEnum.Advisor
  const isAdvisorAdmin = false //user?.role === UsersRoleEnum.Admin
  const isAdmin = user?.role === UsersRoleEnum.Admin
  const isCommentor = user?.role === UsersRoleEnum.Commentor
  const isSuperadmin = user?.isSuperadmin ?? false
  return {
    availableChatSources: user?.business?.availableChatSources,
    availableChatSourcesAndCommitHistory: user?.business?.availableChatSourcesAndCommitHistory,
    availableDocumentationSources: user?.business?.availableDocumentationSources,
    bitbucketConnected: user?.business?.bitbucketConnected || false,
    branchNamesAcceptedDocumentationReviewRunTextsInGithub:
      user?.business?.branchNamesAcceptedDocumentationReviewRunTextsInGithub || [],
    business,
    codeConnected: user?.business?.codeConnected || false,
    codeIndexing: user?.business?.codeIndexing || false,
    confluenceConnected: user?.business?.confluenceConnected || false,
    confluenceIndexing: user?.business?.confluenceIndexing || false,
    defaultChatSources: user?.business?.defaultChatSources || [],
    disableManualReleaseNotesGeneration:
      user?.business?.disableManualReleaseNotesGeneration || false,
    documentationCodeConnected: user?.business?.documentationCodeConnected || false,
    documentationCodeIndexing: user?.business?.documentationCodeIndexing || false,
    documentationProjects: user?.business?.documentationProjects || [],
    documentationRepoNamePath: user?.business?.documentationRepoNamePath || '',
    enableCoverageFeature: user?.business?.enableCoverageFeature || false,
    enableManualDocumentationAuditing: user?.business?.enableManualDocumentationAuditing || false,
    featureFlagFullLink: user?.business?.featureFlagFullLink || '',
    featurebaseConnected: user?.business?.featurebaseConnected || false,
    frontConnected: user?.business?.frontConnected || false,
    githubConnected: user?.business?.githubConnected || false,
    gitlabConnected: user?.business?.gitlabConnected || false,
    hasDocumentationStyleGuide: user?.business?.hasDocumentationStyleGuide || false,
    hasTranslatedDocumentation: user?.business?.hasTranslatedDocumentation || false,
    hideReleaseNoteItemHeaders: user?.business?.hideReleaseNoteItemHeaders || false,
    hubspotConnected: user?.business?.hubspotConnected || false,
    intercomConnected: user?.business?.intercomConnected || false,
    intercomIndexing: user?.business?.intercomIndexing || false,
    isAdmin,
    isAdvisor,
    isAdvisorAdmin,
    isCommentor,
    isPaidPlan,
    isSuperadmin,
    jiraConnected: user?.business?.jiraConnected || false,
    launchdarklyConnected: user?.business?.launchdarklyConnected || false,
    linearConnected: user?.business?.linearConnected || false,
    loading,
    notionConnected: user?.business?.notionConnected || false,
    notionIndexing: user?.business?.notionIndexing || false,
    pendoConnected: user?.business?.pendoConnected || false,
    plan: user?.business?.plan,
    role: user?.role,
    skipDocumentationFindingStepForTasks:
      user?.business?.skipDocumentationFindingStepForTasks || false,
    slackConnected: user?.business?.slackConnected || false,
    unreadUsersActivitiesCount: user?.unreadUsersActivitiesCount || 0,
    user,
    users: user?.business?.users || [],
    zendeskConnected: user?.business?.zendeskConnected || false,
    zendeskIndexing: user?.business?.zendeskIndexing || false,
  }
}
